/**
 * @generated SignedSource<<dd9de65e8a96f55ff9176086acd9e6cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditPayrateInput = {
  clientMutationId?: string | null | undefined;
  hourlyRate?: number | null | undefined;
  payrateId: string;
  startDate?: string | null | undefined;
};
export type EditPayrateMutation$variables = {
  input: EditPayrateInput;
};
export type EditPayrateMutation$data = {
  readonly editPayrate: {
    readonly errors: any | null | undefined;
    readonly payrate: {
      readonly hourlyRate: number | null | undefined;
      readonly id: string;
      readonly startDate: string | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type EditPayrateMutation = {
  response: EditPayrateMutation$data;
  variables: EditPayrateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditPayratePayload",
    "kind": "LinkedField",
    "name": "editPayrate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PayrateNode",
        "kind": "LinkedField",
        "name": "payrate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourlyRate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPayrateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditPayrateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d5c515015dc93aa40e53a001081500df",
    "id": null,
    "metadata": {},
    "name": "EditPayrateMutation",
    "operationKind": "mutation",
    "text": "mutation EditPayrateMutation(\n  $input: EditPayrateInput!\n) {\n  editPayrate(input: $input) {\n    success\n    errors\n    payrate {\n      id\n      startDate\n      hourlyRate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf22686c9c42d94bd3673adfd95bed63";

export default node;
